<template>
  <View gap="sm" align="center" class="alert" :class="[props.variant]">
    <Icon :name="iconName" class="icon" />
    <Text variant="label-small" class="text">
      <div v-html="props.text"></div>
    </Text>
  </View>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { IconName } from '../../values/icons.const';
import Icon from '../icon.vue';
import Text from '../text.vue';
import View from '../view/view.vue';
import { AlertProps, AlertVariant } from './alert-props.interface';

const props = withDefaults(defineProps<AlertProps>(), { variant: 'info' });

const iconMap = new Map<AlertVariant, IconName>([
  ['success', 'check-circle'],
  ['info', 'info-circle'],
  ['warning', 'alert-triangle'],
  ['error', 'slash-circle-01'],
]);
const iconName = computed(() => iconMap.get(props.variant) as IconName);
</script>

<style scoped lang="scss">
.alert {
  padding: var(--t-spacing-sm) var(--t-spacing-md);
  border-radius: var(--t-border-radius-sm);

  background: var(--t-color-neutral-950);
  color: var(--t-color-neutral-100);
  cursor: pointer;

  .text {
    flex-basis: 0;
    flex-grow: 1;
  }

  .icon {
    font-size: var(--t-spacing-lg);
  }

  &.info .icon {
    color: var(--t-color-neutral-500);
  }

  &.success .icon {
    color: var(--t-color-green-400);
  }

  &.error .icon {
    color: var(--t-color-red-400);
  }

  &.warning .icon {
    color: var(--t-color-yellow-500);
  }
}
</style>
